import { reactive, computed } from 'vue'

import searchQueryState from './SearchQuery'

const searchConfigurationState = reactive({
  searchConfigiguration: [],
  initialized: false
})

export default {
  searchConfigurationUse(configuration) {
    const { searchQuery, setSearchType, setAllSearchTypes } = searchQueryState.searchQueryUse()
    const state = searchConfigurationState

    if (configuration && !state.initialized) {
      state.searchConfigiguration = configuration
      setSearchType(configuration.find((x, index) => index === 0).type)
      setAllSearchTypes(configuration.map((x) => x.type))
      state.initialized = true
    }

    function getConfigBySearchType(searchType) {
      const config = state.searchConfigiguration.find((x) => x.type === searchType)
      let combinedCategories = []
      config.categories.forEach(({ items }) => {
        combinedCategories = [...combinedCategories, ...items]
      })
      return { ...config, combinedCategories }
    }
    function getActiveConfig() {
      return getConfigBySearchType(searchQuery.searchType)
    }

    return {
      getActiveConfig,
      getConfigBySearchType,

      searchConfigiguration: computed(() => state.searchConfigiguration)
    }
  }
}
